import { createStore } from "zustand/vanilla";

/**
 * Active-currency store (Zustand, vanilla — no React dependency).
 *
 * Holds the operator's active currency code, hydrated once on session start
 * from the layout loader (`currencyActions.initFromLoader`). This is the single
 * source of truth for which currency the backoffice renders money in.
 *
 * Deliberately NOT in Redux (`app/store/global.ts`) — this feature moves
 * currency state onto Zustand, mirroring the sports-analytics feed-store pattern.
 */
export interface CurrencyState {

  /** Operator's active currency code (e.g. "INR" | "USD"); null when unconfigured. */
  currency: string | null;

  /** Hydrate from a loader/session value. */
  initFromLoader: (currency: string | null) => void;

  /** Clear on logout. */
  reset: () => void;
}

export const currencyStore = createStore<CurrencyState>()((set) => ({
  currency: null,
  // Normalise both null/undefined AND "" to null — an empty string is not a
  // valid currency code and must read as "unconfigured", same as null.
  initFromLoader: (currency) => set({ currency: currency || null }),
  reset: () => set({ currency: null }),
}));
